<template id="list-cmses">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">
          announcement
        </li>
      </ol>
    </nav>
    <!-- List cms -->
    <div class="listCmses" v-if="listCmsMode">
      <div class="row">
        <div class="col-md-4">
          <h3>Announcement</h3>
        </div>
        <div class="col-md-4">
          <searchbox @searchButtonClick="setCurrentKeywordandSearch"></searchbox>
        </div>
        <div class="col-md-4">
          <a href="/announcement/form" class="btn btn-success float-right mr-3">เพิ่ม</a>
        </div>
      </div>
      <paginate v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"></paginate>
      <general-loading v-if="showLoading"></general-loading>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-body" v-for="item in items" v-bind:key="item.id" :style="item.status === 'inactive' ? 'background-color:#FCA5A5;color:#000000;' : ''">
            <div class="row">
              <div class="col-md-10">
                <h4 class="text">
                  <span v-bind:class="{
                    'text-warning': titleIsNotDefined(item.title),
                  }">{{ item.title }}</span>
                </h4>
              </div>
              <div class="col-md-2">
                <div class="form-group float-right">
                  <a class="btn btn-light" v-bind:href="'/announcement/form/' + item.id">แก้ไข</a>
                  <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ConfirmDeleteModal"
                    @click="setForDeleteItemId(item.id)">
                    ลบ
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <span><i class="fa fa-edit" aria-hidden="true"></i>{{ formatDate(item.start_date) }}</span>
                <span>
                 แก้ไขโดย {{ item.updated_by.name }} 
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <paginate v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"></paginate>
      <div v-if="recordNotFound" class="alert alert-warning" role="alert">
        ไม่พบข้อมูล
      </div>
    </div>
    <!-- delete modal    -->
    <general-delete-modal @ConFirmDeleteClick="performDeleteItem"></general-delete-modal>
    <!-- alert modal    -->
    <button style="display: none" type="button" class="btn btn-primary" data-toggle="modal" data-target="#AlertModal"
      ref="decoyAlertModalClick">
      test
    </button>
    <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
  </div>
</template>

<script>
import searchbox from "../_layouts/searchbox.vue";
import paginate from "../_layouts/pagination.vue";

export default {
  components: {
    searchbox,
    paginate,
  },
  //props:['paginate_data'],
  data() {
    return{
    allItems: [], 
    items: [],
    item: {},
    cms_id: "",
     paginate_data: {
        _infos: {},
        _base_item_list_url: "",
      },
      alertMessage: {
        titleClassName: "warning",
        titleMessage: "แจ้งเตือน!!",
        bodyClassName: "warning",
        bodyMessage: "This is alert",
      },
      edit: false,
      recordNotFound: false,
      listCmsMode: true,
      showLoading: true,
      base_item_url: "/cms",
      currentSearchKeyword: "",
      currentPage: 1,
      currentPerpage: 10,
      item_id_for_delete: "",
    }
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.searchItems();
  },
  methods: {
    formatDate(datetime) {
    if (!datetime) return "";
    const date = new Date(datetime);
    return date.toLocaleString("th-TH", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Bangkok",
    });
  },
    titleIsNotDefined(title) {
      return title == "title-not-defined";
    },
    setCurrentKeywordandSearch(searchKeyword) {
      this.currentPage = 1;
      this.currentSearchKeyword = searchKeyword;
      this.searchItems();
    },
    setCurrentPageAndSearch(page) {
      this.currentPage = page;
      this.searchItems();
    },
    searchItems() {
      let url = "/announcement/list";
      url = url + "?keyword=" + this.currentSearchKeyword;
      this.fetchItems(url);
    },
    fetchItems(url) {
    this.showLoading = true;
    axios.get(url)
      .then((response) => {
        const currentDate = new Date();

        const sortedItems = response.data.items.sort((a, b) => {
          if (a.set_as_default === 1 && b.set_as_default !== 1) return -1;
          if (a.set_as_default !== 1 && b.set_as_default === 1) return 1;
          return 0;
        });

        this.allItems = sortedItems.map(item => {
          const endDate = new Date(item?.end_date);
          let announceStatus = "inactive";
          if (!item.end_date || endDate.getTime() > currentDate.getTime()) {
            announceStatus = "active";
          }
          return {
            ...item,
            status: announceStatus
          };
        });

        const total = this.allItems.length;
        const lastPage = Math.ceil(total / this.currentPerpage);

        const infos = {
          _total: total,
          _current_page: this.currentPage,
          _per_page: this.currentPerpage,
          _last_page: lastPage,
          _has_pages: total > this.currentPerpage,
          _has_more_pages: total > (this.currentPage * this.currentPerpage),
          _url_range: Array.from({ length: lastPage }, (_, i) => [i + 1]),
        };

        this.paginate_data = {
          _infos: infos,
          _base_item_list_url: "/announcement/list"
        };

        this.updatePageItems();

        this.showLoading = false;
      })
      .catch((error) => {
        console.log(error);
        this.showLoading = false;
      });
  },

  updatePageItems() {
    const start = (this.currentPage - 1) * this.currentPerpage;
    const end = start + this.currentPerpage;
    this.items = this.allItems.slice(start, end);
  },
    setForDeleteItemId(item_id) {
      this.item_id_for_delete = item_id;
    },
    performDeleteItem() {
      let delete_url = "/announcement/" + this.item_id_for_delete + "/delete";
      axios
        .post(delete_url)
        .then((response) => {
          console.log("response", response);
          response.status == "200"
            ? window.location.href = "/announcement"
            : alert("Error Status:");
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          alert("ไม่สามารถลบได้ กรุณาลองใหม่อีกครั้ง ");
        });
    },
  },
};
</script>